import Vue from 'vue';
import Router from 'vue-router';

import Home from '../views/website_v3/Home';
import Solutions from '../views/website_v3/Solutions';
import Wjw from '../views/website_v3/Solutions/Wjw';
import Zhyy from '../views/website_v3/Solutions/Zhyy';
import Qmjk from '../views/website_v3/Solutions/Qmjk';
import About from '../views/website_v3/About';
import Product from '../views/website_v3/Product';
// import Job from '../views/website_v3/Job';
import Contact from '../views/website_v3/Contact';
import Cooperation from '../views/website_v3/Cooperation';
import SettledIn from '../views/website_v3/SettledIn';

import { locatTo } from '../utils/utils';
// import setSpm from '@alife/set-spm';

Vue.use(Router);

const website_v3Router = new Router({
  mode: 'history',
  base: '/',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/solution',
      name: 'solution',
      component: Solutions,
      meta: {
        spmb: '',
      },
    },
    {
      path: '/solution/wjw',
      name: 'wjw',
      component: Wjw,
      meta: {
        spmb: '14898818',
      },
    },
    {
      path: '/solution/zhyy',
      name: 'zhyy',
      component: Zhyy,
      meta: {
        spmb: '14898841',
      },
    },
    {
      path: '/solution/qmjk',
      name: 'qmjk',
      component: Qmjk,
      meta: {
        spmb: '14898846',
      },
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        spmb: '14898796',
      },
    },
    {
      path: '/product',
      name: 'product',
      component: Product,
      meta: {
        spmb: '',
      },
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        spmb: '',
      },
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      meta: {
        spmb: '',
      },
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: Cooperation,
      meta: {
        spmb: '14907907',
      },
    },
    {
      path: '/settledin',
      name: 'Settledin',
      component: SettledIn,
      meta: {
        spmb: '14907902',
      },
    },
  ],
});

website_v3Router.afterEach(to => {
  // const isMobile = isWirelessDevice();
  let scrollTop = 0;

  const spma = 'a2o2ij';
  const spmb = to.meta.spmb || '';

  // 产品与服务，关于我们，联系我们埋点，路由层面暂时无法处理，到业务入口处理
  if (spmb) {
    console.log(`${spma}.${spmb}`);
    // setSpm(`${spma}.${spmb}`);
  }

  locatTo(scrollTop);
});

export default website_v3Router;
